export default __webpack_public_path__ + "static/media/ky.6d23c238.jpg";